// extracted by mini-css-extract-plugin
export var chatHtmlText = "_k8-2";
export var chatLink = "_k8-0";
export var chatText = "_k8-1";